/* unplugin-vue-components disabled */import { render } from "./AdminListSpeaches.vue?vue&type=template&id=608070ce&scoped=true&ts=true"
import script from "./AdminListSpeaches.vue?vue&type=script&lang=ts"
export * from "./AdminListSpeaches.vue?vue&type=script&lang=ts"

import "./AdminListSpeaches.vue?vue&type=style&index=0&id=608070ce&lang=scss"
import "./AdminListSpeaches.vue?vue&type=style&index=1&id=608070ce&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608070ce"]])

export default __exports__